/* eslint-disable no-undef */
export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $('#js-active-nav-link').parent().parent().find('.dropdown-toggle').addClass('active');

    $('.mol-footerSlider').slick({
        infinite: false,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('.mol-aboutSlider').slick({
        infinite: false,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('#actuajax-filter').submit(function(){
      console.log($('#actuajax-filter').attr('action'));
      $.ajax({
        url: $('#actuajax-filter').attr('action'),
        method: 'POST',
        cacheURL: false,
        data: {
          action: 'axtuajax',
        },
        success: function(res){
          console.log(res);
        },
      });
    })

      // Masonry.
      let $container = $('#grid-container');
      /*
      $container.imagesLoaded(function () {
          $container.masonry({
              itemSelector: '.grid-item',
          });
      });
      */

      $container.masonry({
          itemSelector: '.grid-item',
          columnWidth: 80,
      });

      // Positioning filters
      if (document.getElementById('filtersjs')) {
          let winwidth = window.innerWidth;
          let width = document.getElementById('asidejs').offsetWidth;
          let filters = document.getElementById('filtersjs');

          if (winwidth > 1200) {
            filters.style.width = width + 'px';
          }

          window.onscroll = function() {

              let filtersY = filters.getBoundingClientRect().top + window.scrollY;
              let filtersHeight = filters.offsetHeight;
              let footer = document.getElementById('footerjs');
              let footerY = footer.getBoundingClientRect().top + window.scrollY;

              if (window.pageYOffset > 700 && winwidth > 1200) {
                  if ( filtersY + filtersHeight + 100 < footerY || window.scrollY + window.innerHeight < footerY) {
                      filters.style.position = 'fixed';
                      filters.style.top = '30px';
                  } else {
                      filters.style.position = 'absolute';
                      filters.style.bottom = '50px';
                      filters.style.top = 'unset';
                  }
              } else {
                  filters.style.position = 'relative';
                  filters.style.top = 'unset';
              }
          }

      }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js